import { render } from "./MyAdvers.vue?vue&type=template&id=65f1a0f2&scoped=true"
import script from "./MyAdvers.vue?vue&type=script&lang=js"
export * from "./MyAdvers.vue?vue&type=script&lang=js"

import "./MyAdvers.vue?vue&type=style&index=0&id=65f1a0f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f1a0f2"]])

export default __exports__